<template>
    <span v-if="time">
        <span v-if="afternoon && time.opening_time.hour">,</span>
      <span v-if="time.opening_time.hour">
        <span v-if="!afternoon">{{ $t('store_locator.agency.to') }}</span> {{ time.opening_time.hour }}
      </span>
      <span v-if="time.opening_time.minute">
        : {{ time.opening_time.minute }}
      </span>
      <span v-if="time.closing_time.hour">
        - {{ time.closing_time.hour }}
      </span>
      <span v-if="time.closing_time.minute">
        : {{ time.closing_time.minute }}
      </span>
    </span>
  </template>
  
  <script>
  export default {
    props: {
      time: {
        type: Object,
        required: true,
      },
      afternoon: {
        type: Boolean,
        required: false,
        default: false
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
    span {
        font-family: $f-nouvelR-regular;
        font-size: 14px;
        line-height: 16px;
    }
  </style>